﻿﻿import { ClusterStatus } from '../enums/index';

export interface IUpdateClusterStatus {
    clusterId: number;
    clusterStatus: ClusterStatus;
}
